// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2G1S9","tab":"ProcedureTabs_tab__1uAQJ"};